// Helper function to get padding
const getButtonPadding = size => {
  switch (size) {
    case 'small':
      return '7px 12px'
    case 'large':
      return '11px 16px'
    case 'medium':
    default:
      return '9px 16px'
  }
}

export default getButtonPadding
